<template>
  <div>
    <!-- 全局消息提醒 -->
    <div class="message-notification" v-if="showNotificationMessage && $route.path!='/home/chat'" @click="openChatFromNotification">
      <div class="notification-content">
        <div class="notification-avatar" v-if="notificationData.icon">
          <img 
            :src="notificationData.icon"
            alt="头像" 
            class="avatar-img"
          />
        </div>
        <div class="notification-icon" v-else>
          <i class="el-icon-message"></i>
        </div>
        <div class="notification-text">
          <div class="notification-title">{{ notificationData.title }}</div>
          <div class="notification-message">{{ notificationData.message }}</div>
        </div>
        <div class="notification-close" @click.stop="closeNotification">
          <i class="el-icon-close"></i>
        </div>
      </div>
    </div>
    <!-- 最小化后的悬浮按钮 -->
    <div class="minimized-chat" v-show="isMinimized && $route.path!='/home/chat'" @click="openChatFromNotification">
      <div class="minimized-icon">
        <i class="el-icon-chat-dot-round"></i>
             <span class="unread-badge" v-if="unreadCount > 0">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
      </div>
      <div class="minimized-tooltip">点击恢复聊天</div>
    </div>
    <GlobalChatDialog ref="globalChatDialog"></GlobalChatDialog>
  </div>
</template>

<script>
import GlobalChatDialog from "@/components/common/ChatDialog.vue";
import imEngine from "@/utils/imEngine";

export default {
  name: 'GlobalMessageNotification',
  components: {GlobalChatDialog},
  data() {
    return {
      isMinimized: false ,// 新增最小化状态
      showNotificationMessage: false,
      notificationData: {
        title: '',
        message: '',
        icon: '',
        chat: null
      }
    };
  },
  computed:{
    unreadCount() {
      let unreadCount = 0;
      const conversations = this.chatStore.conversations;
      conversations.forEach((conv) => {
        if (!conv.isDnd) {
          unreadCount += conv.unreadCount
        }
      })
      return unreadCount;
    }
  },
  mounted() {
    // 监听全局消息提醒事件
    this.$eventBus.$on('showGlobalNotification', this.showNotification);
    this.$eventBus.$on('showGlobalChatDialog', ()=>{
      this.$refs.globalChatDialog.show();
    });
    this.$eventBus.$on('globalChatDialoginit', () => {
      imEngine.ensureStarted(this);
    });
    this.$eventBus.$on('showMinimizedChat', ()=>{
      this.isMinimized=true;
    });
  },
  beforeDestroy() {
    // 移除事件监听
    this.$eventBus.$off('showGlobalNotification', this.showNotification);
    this.$eventBus.$off('showGlobalChatDialog')
    this.$eventBus.$off('globalChatDialoginit')
  },
  methods: {
    showNotification(data) {
      // 显示页面内通知
      this.notificationData = {
        title: data.title,
        message: data.message,
        icon: data.icon,
        chat: data.chat
      };
      this.showNotificationMessage = true;
      
      // 5秒后自动关闭通知
      setTimeout(() => {
        this.closeNotification();
      }, 15000);
    },
    
    openChatFromNotification() {
      if (this.notificationData.chat) {
        this.chatStore.setActive(this.notificationData.chat.key);
      }
      this.$refs.globalChatDialog.show();
      // 关闭通知
      this.closeNotification();
      this.isMinimized=false;
    },
    
    closeNotification() {
      this.showNotificationMessage = false;
      this.notificationData = {
        title: '',
        message: '',
        icon: '',
        chat: null
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.message-notification {
  position: fixed;
  top: 20px;
  right: 20px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  padding: 10px 15px;
  cursor: pointer;
  z-index: 3003;
  border: 1px solid #eee;
  animation: slideInRight 0.3s ease-out;
  transition: all 0.3s ease;

  &:hover {
    background-color: #f5f5f5;
    transform: translateX(-5px);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  }
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

.notification-content {
  display: flex;
  align-items: center;
  flex: 1;
}

.notification-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 10px;
  flex-shrink: 0;
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.notification-icon {
  margin-right: 10px;
  font-size: 24px;
  color: #409eff;
}

.notification-text {
  flex: 1;
}

.notification-title {
  font-weight: bold;
  font-size: 14px;
  color: #333;
  margin-bottom: 2px;
}

.notification-message {
  font-size: 12px;
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 200px;
}

.notification-close {
  margin-left: 10px;
  font-size: 18px;
  color: #999;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s;

  &:hover {
    background-color: #e0e0e0;
    color: #333;
  }

  &:active {
    transform: scale(0.95);
  }
}
.minimized-chat {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 50px;
  height: 50px;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 2017;
  border: 1px solid #eee;
  transition: all 0.3s ease;

  &:hover {
    background-color: #f5f5f5;
    transform: scale(1.1);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
  }
}

.minimized-icon {
  position: relative;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #409eff;

  .unread-badge {
    position: absolute;
    top: -5px;
    right: -5px;
    background-color: #f56c6c;
    color: #fff;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: bold;
    border: 2px solid #fff;
  }
}

.minimized-tooltip {
  position: absolute;
  top: -30px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 12px;
  white-space: nowrap;
  z-index: 2018;
  opacity: 0;
  transition: opacity 0.3s ease-in-out;
  pointer-events: none;
}

.minimized-chat:hover .minimized-tooltip {
  opacity: 1;
}
</style> 